import React, { useContext } from "react";
import { Select } from "antd";
import { VILLAGES } from "../../../constants/constants";
import { AppContext } from "../../../context";
import { FIELD_WIDTHS } from "../../../config/layoutConfig";

function SelectVillage({ setVillage }) {
  const { t } = useContext(AppContext);
  return (
    <div>
      <div style={{ marginTop: 10, display: "inline" }}>
        <strong>{t("selectedVillage")}:</strong>
      </div>
      <Select
        placeholder={t("village")}
        options={VILLAGES}
        onChange={setVillage}
        bordered={false}
        style={{ marginTop: 10, width: FIELD_WIDTHS.L }}
      />
    </div>
  );
}

export default SelectVillage;
